import { createSlice } from "@reduxjs/toolkit";


export const assetSlice = createSlice({
    name: 'assets',
    initialState: {
        value: [],
    },
    reducers: {
        addAsset: (state, action) => {
            state.value.unshift(action.payload);
            //state.value.push( action.payload );
        },
        addMany: (state, action) => {
            state.value = [ ...state.value, ...action.payload ];
        },
        setAssets: (state, action) => {
            state.value = action.payload;
        },
        updateAsset: (state, action) => {
            const index = state.value.findIndex(a => a.id === action.payload.id);
            if (index !== -1) {
                state.value[index] = action.payload;
            }
        },
        deleteAsset: (state, action) => {
            const index = state.value.findIndex(a => a.id === action.payload);
            if (index !== -1) {
                state.value = [ ...state.value.slice(0, index), ...state.value.slice(index + 1) ];
            }
        },
        clearAssets: (state) => {
            state.value = [];
        }
    }
});

export const { addAsset, addMany, setAssets, updateAsset, deleteAsset, clearAssets } = assetSlice.actions;

export default assetSlice.reducer;